import {
  DialogHeader,
  DialogTitle,
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";

import { z } from "zod";
import { useQuery } from "@tanstack/react-query";
import { client } from "@/client";
import { useTranslation } from "react-i18next";
import React from "react";
import { TzPicker } from "./-tz-picker";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import { AccountPicker } from "./-account-picker";
import { RolePicker } from "./-role-picker";

const userFormSchema = z.object({
  firstName: z.string().min(1, { message: "Please enter a valid name" }),
  lastName: z.string().min(1, { message: "Please enter a valid name" }),
  profileImg: z.instanceof(File).optional(),
});

interface DashboardSettingsProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const DashboardSettings = ({
  open,
  onOpenChange,
}: DashboardSettingsProps) => {
  const { t } = useTranslation();
  const account = useQuery(client.users.me.asQueryOptions());
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="whitespace-pre-line max-w-[30vw]">
        <DialogHeader>
          <DialogTitle>{t("dashboardSettings")}</DialogTitle>
        </DialogHeader>
        <div className={cn("space-y-1")}>
          <Label>{t("timezone")}</Label>
          <TzPicker />
        </div>
        <div className={cn("space-y-1")}>
          <Label>{t("account")}</Label>
          <AccountPicker />
        </div>
        {account?.data?.role === "SuperAdmin" && (
          <div className={cn("space-y-1")}>
            <Label>{t("role")}</Label>
            <RolePicker />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
